import * as React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useState } from "react";

export default function PaginationButtons(props: any) {
  const {
    handleChange,
    pageCount,
    pageNumber,
    handlePerPage,
    perPage,
    enableAll,
    hideLimit = false,
  } = props;
  const [jumpPage, setJumpPage] = useState<number | string>("");
  const setChange = (event: React.ChangeEvent<unknown>, value: number) => {
    handleChange(value);
  };

  const handleJump = () => {
    let page = Number(jumpPage);
    if (page >= 1 && page <= Math.ceil(pageCount / perPage)) {
      handleChange(page);
    }
    setJumpPage(""); // clear input after jump
  };

  return (
    <div className="p-2">
      <div className="bg-[#EFEEED] flex flex-col md:flex-row w-full justify-between p-2 gap-4">
        <div className="p-1 mt-2">
          Showing {(pageNumber - 1) * perPage + 1} to{" "}
          {pageCount < pageNumber * perPage ? pageCount : pageNumber * perPage}{" "}
          of {pageCount} entries
        </div>

        <div className="flex flex-wrap p-1 items-center gap-2">
          <div className="p-1 mr-2">Records per page</div>
          <select
            className="border border-[#595754] rounded-md px-3 mr-4"
            value={perPage}
            onChange={(e) => handlePerPage(e.target.value)}
            name="rowsPerPage"
            id="rowsPerPage"
          >
            {enableAll && <option value={pageCount}>All</option>}

            {!hideLimit && (
              <>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
                <option value={500}>500</option>
                <option value={1000}>1000</option>

              </>
            )}
            {/* <option value={pageCount}>All</option> */}
          </select>

          <Stack spacing={2} direction="row" alignItems="center">
            <Pagination
              count={Math.ceil(pageCount / perPage)}
              showFirstButton
              showLastButton
              page={pageNumber}
              onChange={setChange}
            />
          </Stack>

          {/* Jump to page */}
          <div className="flex items-center gap-1">
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={jumpPage}
              onChange={(e) => {
                const value = e.target.value;
                const maxPage = Math.ceil(pageCount / perPage);

                // Allow only digits
                if (/^\d*$/.test(value)) {
                  if (value === "") {
                    setJumpPage("");
                  } else {
                    const numberValue = Number(value);
                    if (numberValue >= 1 && numberValue <= maxPage) {
                      setJumpPage(numberValue);
                    } else if (numberValue < 1) {
                      setJumpPage(1);
                    } else if (numberValue > maxPage) {
                      setJumpPage(maxPage);
                    }
                  }
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleJump();
                // Prevent typing e, +, -, ., etc.
                if (e.key.length === 1 && !/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              placeholder="Jump to"
              className="border border-[#595754] rounded-md px-2 w-20 text-[16px]"
            />
            <button
              onClick={handleJump}
              className="bg-primary text-white px-3 rounded-md"
            >
              Go
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
